import { Backdrop, CircularProgress } from "@mui/material";
import { getAuth, signOut } from "firebase/auth";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const navigate = useNavigate();

  const logout = useCallback(async () => {
    const auth = getAuth();
    await signOut(auth);
    navigate("/");
  }, [navigate]);

  useEffect(() => {
    logout();
  }, [logout]);

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
